export default __webpack_public_path__ + "static/media/Cognisphere.c657f1b3.png";